module.exports = __webpack_public_path__ + "static/travel-insurance-banner-06fdb1c45e157b24d03e9a0b8c8bea3a.jpg";